module.exports = __webpack_public_path__ + "f06d254d5978e4b0223fa242514e55e1.svg";